// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see LocalEditorialLoadEditorialEvent
 */
export var LocalEditorialLoadEditorial = function (_a) {
    var editorialToken = _a.editorialToken, attributionKey = _a.attributionKey;
    return ({
        name: "LocalEditorial Load Editorial",
        parameters: {
            cdf_entity: "LocalEditorial",
            cdf_action: "Load",
            editorial_token: editorialToken !== undefined && editorialToken !== null ? editorialToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attribution_key: attributionKey !== undefined && attributionKey !== null ? attributionKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
